export default __webpack_public_path__ + "static/media/web_hosting_img.e85ddf2d.svg";